import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import CATEGORIES from "utils/categories";
import { isPopulated } from "utils/helpers";
import NotificationMessage from "./NotificationMessage";
import "styles/CompleteNotification.scss";

class NotificationContainer extends Component {
  state = {
    showNote: false
  };
  openNotification = () => this.setState({ showNote: true });
  onSameCategory = (currLink, prevLink) => {
    if (!prevLink || !currLink) return true;
    const currFirst = currLink.slice(1, currLink.length).split("/")[0];
    const prevFirst = prevLink.slice(1, prevLink.length).split("/")[0];
    return currFirst === prevFirst;
  };

  componentDidUpdate = prevProps => {
    // return if shown note before
    if (this.state.showNote) return;
    // return if from an input hash
    const { recommendations } = this.props;
    if (recommendations.length > 0) return;
    // return if no path change
    const { pathname } = this.props.location;
    const { pathname: prevPath } = prevProps.location;
    const onSameCategory = this.onSameCategory(pathname, prevPath);

    if (onSameCategory) return;
    // only set State if there is a cat complete
    if (this.catComplete()) this.openNotification();
  };

  catComplete = () => {
    return CATEGORIES.some(isPopulated);
  };

  render() {
    if (this.state.showNote) {
      return <NotificationMessage />;
    } else {
      return null;
    }
  }
}

const mapStateToProps = store => {
  const { recommendations } = store.recommendationsReducer;
  return { recommendations };
};

export default withRouter(connect(mapStateToProps)(NotificationContainer));
